import { RentControlState } from '../../../../../../../@types/state-types'

export const RENT_CONTROL_MAX_SURCHARGE_FACTOR = 1.1

export const calculateRentControlMaxValue = (rentIndexMaxValue: number) =>
  rentIndexMaxValue * RENT_CONTROL_MAX_SURCHARGE_FACTOR

const normalizeCity = (city?: string) => city?.trim().toLocaleLowerCase()

export const getCurrentRentControlApplies = (
  rentControlState: RentControlState,
  currentCity?: string
): RentControlState['rentControlApplies'] => {
  const normalizedRentControlCity = normalizeCity(rentControlState.city)
  const normalizedCurrentCity = normalizeCity(currentCity)

  if (rentControlState.isPending || !normalizedCurrentCity || normalizedRentControlCity !== normalizedCurrentCity) {
    return undefined
  }

  return rentControlState.rentControlApplies
}
